import { render, staticRenderFns } from "./SearchResultCreator.vue?vue&type=template&id=7b7022a4&scoped=true"
import script from "./SearchResultCreator.vue?vue&type=script&lang=js"
export * from "./SearchResultCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7022a4",
  null
  
)

export default component.exports